import {
  EcheancePrelevement,
  SaisiePaiement,
  TypePromo
} from 'src/app/core/models/form-state.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from 'src/app/shared/components/base-component/base-component.component';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { AppResource } from 'src/app/app.resource';
import { PaymentEnum } from 'src/app/shared/models/enum/payment.enum';
import { State } from 'src/app/core/state/core.state';
import * as fromPayment from 'src/app/core/state/payment';
import * as fromSubscriber from 'src/app/core/state/subscriber';
import * as fromContext from 'src/app/core/state/context';
import * as fromTarif from 'src/app/core/state/tarification';
import * as fromDevis from 'src/app/core/state/devis';
import * as fromService from 'src/app/core/state/service';
import * as fromContract from 'src/app/core/state/contract';
import * as fromInfo from 'src/app/core/state/info';
import * as fromPath from '../../../core/state/path';
import { DatePipe } from '@angular/common';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { HeaderVM } from 'src/app/shared/models/components/headerVm';
import { QuestionVM } from 'src/app/shared/models/components/questionVm';
import { MatomoTracker } from 'ngx-matomo-client';
import { ContractService } from 'src/app/api/services/contract.service';
import { ApiRequestBodyUtils } from 'src/app/shared/utils/apiRequestBodyUtils';
import { ApiResponseBodyUtils } from 'src/app/shared/utils/apiResponseBodyUtils';
import { lastValueFrom, map, take } from 'rxjs';
import { DateUtils } from 'src/app/shared/utils/dateUtils';
import { Stepper } from 'src/app/core/models/stepper.model';
import { PathType } from 'src/app/core/enums/path-type.enum';
import { environment } from 'src/environments/environment';
import { AppConfig } from 'src/app/app.config';

interface Prelevement {
  text: string;
  value: string;
}

interface AccountOwner {
  value: boolean;
  text: string;
}

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PaymentComponent extends BaseComponent implements OnInit {
  headerStep!: HeaderVM;
  override question!: QuestionVM;
  stepB: boolean = false;
  displayModal: boolean = false;
  contractAlreadyExist: boolean = false;

  mensuel: boolean = false;
  trimestriel: boolean = false;
  annuel: boolean = false;

  minDate!: Date;
  disabledDate: boolean = false;

  //Si conseiller ou client
  isAdvisor: boolean = false;
  promoMonthOffered: boolean = false;

  //Form
  echeancePrelevement!: EcheancePrelevement;
  dateStarting?: string;
  prelevements!: Prelevement[];
  selectedPrelevement!: Prelevement | undefined;
  valueIBAN!: string;

  accountOwners!: AccountOwner[];
  selectedAccountOwner: AccountOwner | undefined;

  paymentForm!: FormGroup;
  paymentEnum = PaymentEnum;

  isLoading: boolean = false;
  displayError: boolean = false;
  displayErrorIBAN: boolean = false;

  displayModalOwner: boolean = false;
  url!: string;

  get dateDemarrage() {
    return this.paymentForm.get('dateDemarrage');
  }

  get prelevement() {
    return this.paymentForm.get('prelevement');
  }

  get iban() {
    return this.paymentForm.get('iban');
  }

  get phone() {
    return this.paymentForm.get('phone');
  }

  get accountOwner() {
    return this.paymentForm.get('accountOwner');
  }

  get brand() {
    return this.appConfig.getConfig('brand');
  }

  constructor(
    store: Store<State>,
    resources: AppResource,
    tracker: MatomoTracker,
    private router: Router,
    private contractService: ContractService,
    private datepipe: DatePipe,
    @Inject(AppConfig) private appConfig: AppConfig
  ) {
    super(store, resources, tracker);

    this.headerStep = new HeaderVM(
      this.brand === 'HM' ? this.resource.header.stepContract : this.resource.header.stepSample,
      3,
      this.resource.header.subStepPayment,
      8
    );
    this.question = new QuestionVM(this.resource.question.payment);

    this.prelevements = [
      { text: 'Le 5 du mois', value: '5' },
      { text: 'Le 10 du mois', value: '10' },
      { text: 'Le 15 du mois', value: '15' }
    ];

    this.accountOwners = [
      { text: this.resource.payment.accountOwnerYes, value: true },
      { text: this.resource.payment.accountOwnerNo, value: false }
    ];
  }

  override async ngOnInit() {
    super.ngOnInit();

    this.initForm();

    this.loadStateData();
    let currentDate: Date = new Date();
    currentDate.setDate(currentDate.getDate() + 15);
  }

  private initForm() {
    this.paymentForm = new FormGroup(
      {
        dateDemarrage: new FormControl<string | null>(null, {
          validators: [Validators.required],
          nonNullable: true
        }),
        prelevement: new FormControl<string | null>(null, {
          validators: [Validators.required],
          nonNullable: true
        }),
        iban: new FormControl<string | null>(null, {
          validators: [Validators.required],
          nonNullable: true
        }),
        phone: new FormControl<string | null>(null, {
          validators: [
            Validators.required,
            Validators.pattern(
              /^(?:(?:(?:06|07)[ ]?(?:\(0\)[ ]?)?)|0){1}[6-7]{1}([ .-]?)(?:\d{2}\1?){3}\d{2}$/g
            )
          ],
          nonNullable: true
        }),
        accountOwner: new FormControl<boolean | null>(null, {
          validators: [Validators.required],
          nonNullable: true
        })
      },
      {
        updateOn: 'change'
      }
    );
  }

  private async loadStateData() {
    let path = await lastValueFrom(this.store.select(fromPath.selectPathType).pipe(take(1)));

    if (path == PathType.HOUSING_SOLIDARITY) this.url = environment.wcbMRH_S;
    else this.url = environment.wcbMRH_C;

    this.store.select(fromSubscriber.selectSubscriber).subscribe(res => {
      const telephone = res.subscriber?.Telephone;
      if (telephone && (telephone.startsWith('06') || telephone.startsWith('07')))
        this.phone?.setValue(res.subscriber?.Telephone);
    });

    this.store.select(fromContext.selectContext).subscribe(res => {
      if (res.contextData != null)
        if (res.contextData?.ModeConnexion != 'COB') this.isAdvisor = true;
    });

    this.store.select(fromPayment.selectPayment).subscribe(res => {
      switch (res.payment.EcheancePrelevement) {
        case EcheancePrelevement.Mensuel:
          this.mensuel = true;
          break;
        case EcheancePrelevement.Trimestriel:
          this.trimestriel = true;
          break;
        case EcheancePrelevement.Annuel:
          this.annuel = true;
          break;
        default:
          this.mensuel = true;
          break;
      }

      this.selectedPrelevement = this.prelevements.find(obj => {
        if (res.payment != null) return obj.value === res.payment.JourPrelevement;
        else return undefined;
      });

      this.dateStarting = DateUtils.IsoToDayMonthYear(res.payment.DateDemarrage) ?? undefined;

      this.valueIBAN = res.payment.IBAN;
      this.selectedAccountOwner = this.accountOwners.find(obj => {
        if (res.payment != null) return obj.value === res.payment.TitulaireCompte;
        else return undefined;
      });

      if (res.payment.Telephone && res.payment.Telephone != '')
        this.phone?.setValue(res.payment.Telephone);
    });

    this.store.select(fromService.selectService).subscribe(res => {
      if (!this.dateStarting) {
        if (res.saisieChoixServices.ResAncAss) {
          if (res.saisieChoixServices.ResiliationAncienneAssurance?.DemenagementPlusUnAn) {
            let date = new Date(Date.now());
            date = new Date(date.setDate(date.getDate() + 46));
            this.dateStarting = DateUtils.DateToDayMonthYear(date) ?? undefined;
            this.disabledDate = true;
          } else if (
            res.saisieChoixServices.ResiliationAncienneAssurance?.DemenagementPlusUnAn == false
          ) {
            let date = new Date(
              res.saisieChoixServices.ResiliationAncienneAssurance.MoisDemarrageContrat
            );
            this.dateStarting =
              DateUtils.DateToDayMonthYear(new Date(date.setMonth(date.getMonth() + 12))) ??
              undefined; // + 12 mois
            this.disabledDate = true;
          }
        } else {
          let date = new Date(Date.now());
          this.minDate = new Date(date.setDate(date.getDate() + 1));
        }
      }
    });

    // Retrieve promotion informations
    const promotion = await lastValueFrom(
      this.store.select(fromTarif.selectTarificationPromotion).pipe(take(1))
    );

    this.promoMonthOffered = promotion?.TypePromo === TypePromo.MoisOfferts;
  }

  updateClickButton(value: string) {
    switch (value) {
      case PaymentEnum.Mensuel:
        if (!this.mensuel) {
          this.mensuel = !this.mensuel;
          this.trimestriel = false;
          this.annuel = false;
          this.echeancePrelevement = EcheancePrelevement.Mensuel;
        }
        break;
      case PaymentEnum.Trimestriel:
        if (!this.trimestriel) {
          this.mensuel = false;
          this.trimestriel = !this.trimestriel;
          this.annuel = false;
          this.echeancePrelevement = EcheancePrelevement.Trimestriel;
        }
        break;
      case PaymentEnum.Annuel:
        if (!this.annuel) {
          this.mensuel = false;
          this.trimestriel = false;
          this.annuel = !this.annuel;
          this.echeancePrelevement = EcheancePrelevement.Annuel;
        }
        break;
    }
  }

  public showModalDialog() {
    if (this.selectedAccountOwner?.value === false) this.displayModalOwner = true;
    else this.displayModal = true;
  }

  public async validPayment() {
    this.isLoading = true;

    const saisiePaiement: SaisiePaiement = {
      EcheancePrelevement: this.echeancePrelevement,
      DateDemarrage: DateUtils.DayMonthYearToIso(this.dateDemarrage?.value) ?? undefined,
      JourPrelevement: this.selectedPrelevement?.value,
      IBAN: this.iban?.value,
      Telephone: this.phone?.value,
      TitulaireCompte: this.selectedAccountOwner?.value
    };

    this.store.dispatch(
      fromPayment.patchPayment({
        payload: saisiePaiement
      })
    );

    this.store.dispatch(
      fromPayment.changeValidationStatus({
        isValid: true
      })
    );

    // Retrieve context
    const context = await lastValueFrom(
      this.store.select(fromContext.selectContextId).pipe(take(1))
    );

    // Retrieve devis ID
    let devisId = await lastValueFrom(
      this.store.select(fromDevis.selectDevisState).pipe(
        take(1),
        map(d => d.NumeroDevis)
      )
    );

    if (!devisId) {
      const contextData = await lastValueFrom(
        this.store.select(fromContext.selectContextData).pipe(take(1))
      );
      devisId = contextData?.RefDevis!;
    }

    // Retrieve service
    const serviceState = await lastValueFrom(
      this.store.select(fromService.selectService).pipe(take(1))
    );

    // Check IBAN
    const bodyIbanCheck = ApiRequestBodyUtils.GenerateCheckIbanRequestBody(
      context!,
      saisiePaiement.IBAN
    );

    this.contractService.checkIBAN(bodyIbanCheck).subscribe({
      next: resIbanCheck => {
        if (!resIbanCheck.IBANValide) {
          this.isLoading = false;
          this.displayModal = false;
          this.displayErrorIBAN = true;
        } else {
          // Create contract
          const bodyContract = ApiRequestBodyUtils.GenerateContractCreateRequestBody(
            context!,
            devisId,
            null,
            serviceState.saisieChoixServices,
            saisiePaiement
          );

          this.contractService.createContract(bodyContract).subscribe({
            next: resContract => {
              // Store returned informations about contract in the state
              const contractInfos = ApiResponseBodyUtils.ExtractContractResponseBody(resContract);

              this.store.dispatch(
                fromContract.patchContract({
                  payload: contractInfos
                })
              );

              // Redirection
              if (this.isAdvisor) {
                this.stepB = true;
              } else {
                this.router.navigate(['/electronicsignature']);
              }

              this.updateStepper();
            },
            error: resContract => {
              this.isLoading = false;
              this.displayModal = false;
              if (resContract.error?.status === 400) {
                this.contractAlreadyExist = true;
              } else {
                this.displayError = true;
              }
            },
            complete: () => {
              this.isLoading = false;
              this.displayModal = false;
            }
          });
        }
      },
      error: () => {
        this.isLoading = false;
        this.displayModal = false;
        this.displayError = true;
      }
    });
  }

  public cancelPayment() {
    this.displayModal = false;
  }

  async updateStepper() {
    let stepper = await lastValueFrom(this.store.select(fromInfo.selectStepper).pipe(take(1)));
    var tmpStepper = JSON.parse(JSON.stringify(stepper)) as Stepper;

    let title = tmpStepper.contract.titles.find(
      (x: { libelle: string }) => x.libelle == this.resource.stepper.sampling
    );

    let subtitleS = title?.subtitles.find(
      (x: { url: string }) => x.url == this.resource.stepper.payment
    );

    if (subtitleS) {
      subtitleS.isValid = true;
      subtitleS.isActive = true;
    }

    let titleN = tmpStepper.contract.titles.find(
      (x: { libelle: string }) => x.libelle == this.resource.stepper.signature
    );

    if (titleN) titleN.isActive = true;

    let subtitleNS = titleN?.subtitles.find(
      (x: { url: string }) => x.url == this.resource.stepper.electronicsignature
    );

    if (subtitleNS) {
      subtitleNS.isActive = true;
    }

    this.store.dispatch(fromInfo.updateStepper({ payload: tmpStepper }));
  }

  onCancel() {
    this.displayModalOwner = false;
  }

  goToLink(url: string) {
    window.open(url, '_blank');
  }

  getClass(value: boolean) {
    return value ? 'activeP-ES' : 'inactiveP-ES';
  }
}
